import SiafLiteApiRepository from "../../external/siafLiteApi";

class CfopService {
  constructor() {
    this.urlBase = "/fiscal/cfop";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAllAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default CfopService;
